<div class="spinner-border text-primary landingspinner" style="width: 5rem; height: 5rem;" role="status">
  <span class="sr-only">Loading...</span>
</div>
